<script lang="typescript">
    import { getContext, onMount } from 'svelte'

    export let comment
    let commentText = null

    const editComment: (comment) => void = getContext('editComment')
    const modifyComment: (comment) => void = getContext('modifyComment')

    const abort = () => {
        editComment(null)
    }

    const submit = () => {
        modifyComment({
            ...comment,
            text: commentText
        })
        editComment(null)
    }

    onMount(() => {
        commentText = comment.text
    })
</script>

<div class="edit-comment">
    <div class="form-group">
        <textarea class="form-control" name="edit-comment" cols="30" rows="5" bind:value={commentText}></textarea>
    </div>
    <div class="form-group justify-content-center">
        <input class="btn btn-primary" type="submit" value="Abschicken" on:click|preventDefault={submit}>
        <input class="btn btn-outline-primary" type="submit" value="Abbrechen" on:click={abort}>
    </div>
</div>
